import Styled, { css } from "styled-components";
// import {
//   highlightColor,
//   primaryColor,
//   backgroundColor,
//   borderColor,
// } from "./theme";

export const CenterScreen = Styled.div`
    color:${props => props.theme.secondary};
    display:flex;
    flex-direction:row;
    justify-content:center;
    align-items:center;
    height:100vh;
    margin:auto;
`;

export const Container = Styled.div`
  margin:20px;
  flex:1;
`;

export const Title = Styled.div`
  font-size:22px;
  font-weight:500;
  color: ${props => props.theme.warningLight};
`;
export const Subtitle = Styled.div`
  font-size:16px;
  font-weight:500;
  color: ${props => props.color || props.theme.primaryDark};
  font-weight:bold;
`;

export const Caption = Styled.div`
  padding:${props => props.padding || "0"}px;
  font-size:12px;
  font-weight:300;
  color: ${props => props.color || props.theme.primaryDark};
`;

export const Horizontal = Styled.div`
  display:flex;
  flex-direction:row;
`;

export const SmallLogo = Styled.div`
  flex:1;
  margin:auto;
  font-size:24px;
  font-weight:bold;
  text-align:center;
`;

export const Padding = Styled.div`
padding:${props => props.value}px;
padding-left:${props => props.left}px;
padding-right:${props => props.right}px;
padding-top:${props => props.top}px;
padding-bottom:${props => props.bottom}px;
`;

export const PaddedDescText = Styled.div`
  padding:20px;
  width:100%;
  height:100%;
  margin:auto;
  text-align:center;
`;

export const FloatingButton = Styled.div`
  position:fixed;
  display:flex;
  justify-content:center;
  bottom:40px;
  right:40px;
  padding:12px;
  z-index:10;
  background-color:${props => props.theme.primary};
  color:white;
  border-radius:50%;
  cursor:pointer;
`;
export const Button = Styled.div`
  display:flex;
  width:${props => props.width || "auto"};
  justify-content:center;
  text-align:center;
  align-items:center;
  font-weight:500;
  cursor:pointer;
  background-color:${props => "white" || props.theme.primary};
  padding:4px 12px;
  border-radius:4px;
  margin:${props => props.margin || 4}px;
  color:${props => props.color || "white"};
`;

export const Row = Styled.div`
  display: flex;
  width: ${props => props.width || "100%"};
  justify-content: ${props => props.justify || "inherit"};
  align-items: ${props => props.align || "inherit"};
  ${props =>
    props.vertCenter &&
    css`
      align-items: center;
    `};
`;

export const Col = Styled.div`
  display: flex;
  flex-direction: column;
  height: ${props => props.height || "100%"};
  justify-content: ${props => props.justify || "inherit"};
  padding: ${props => props.padding};
  align-items: ${props => props.align || "inherit"};
`;

export const FormContainer = Styled.div`
    width:60%;
`;
export const SizedBox = Styled.div`
  position:relative;
  display:${props => props.display};
  height: ${props => props.height + "px"};
  width: ${props => props.width + "px"};
  padding: ${props => props.padding};
  margin: ${props => props.margin};
  background: ${props => props.background};
  justify-content: ${props => props.justify};
`;

export const Pointer = Styled.div`
  size:14px;
  padding:4px;
  cursor:pointer;
  color:black;
`;

export const AbsoluteChild = Styled.div`
  z-index:99;
  position:absolute;
  top:${props => props.top || null};
  bottom:${props => props.bottom || null};
  right:${props => props.right || null};
  left:${props => props.left || null};
`;

export const CustomCard = Styled.div`
  margin:${props => props.margin || 4}px;
  border-radius:12px;
  border: 1px solid black;
  border-color: ${props => props.theme.warningExtraLight};
`;

export const Grid = Styled.div`
  display: grid;
  grid-template-columns: repeat(
    auto-fit,
    minmax(${props => props.width || "150px"}, 1fr)
  );
  grid-gap: 24px;
`;
